import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxMaskModule } from 'ngx-mask';
import { ReportesIngresosComponent } from './reportes-ingresos/reportes-ingresos.component';
import { ReportesGastosComponent } from './reportes-gastos/reportes-gastos.component';
import { ReportesInventarioComponent } from './reportes-inventario/reportes-inventario.component';
import { ReportesVentasComponent } from './reportes-ventas/reportes-ventas.component';

const routes: Routes = [
	{ path: 'inventario', component: ReportesInventarioComponent },
	{ path: 'ventas', component: ReportesVentasComponent },
	{ path: 'gastos', component: ReportesGastosComponent },
	{ path: 'ingresos', component: ReportesIngresosComponent },
	{ path: '', redirectTo: 'index', pathMatch: 'full' },
];



@NgModule({
  declarations: [
  
    ReportesIngresosComponent,
       ReportesGastosComponent,
       ReportesInventarioComponent,
       ReportesVentasComponent
  ],
  imports: [
    CommonModule,
	RouterModule.forChild(routes),
	FormsModule,
	ReactiveFormsModule,
	NgxKuvUtilsModule,
	NgbModalModule,
	NgbNavModule,
	NgxKuvToolsModule,
	NgxMaskModule,
	NgSelectModule
  ]
})
export class ReportesModule { }
